import { INTEGRATION_KEY_PREFIX } from './constants'

/** `INTEGRATION_KEY_V1_` prefix 키 = protocol/dev 상태 (송신·덮어쓰기 차단 대상). */
export const IS_INTERNAL_INTEGRATION_KEY = (key: string): boolean =>
  key.startsWith(INTEGRATION_KEY_PREFIX)

/** Storage 통째 직렬화 — internal key 제외. sender 의 SYNC_SUCCESS payload 생성 시 사용. */
export const serializeStorage = (target: Storage): Record<string, string> => {
  const out: Record<string, string> = {}
  for (let i = 0; i < target.length; i++) {
    const key = target.key(i)
    if (key === null) continue
    if (IS_INTERNAL_INTEGRATION_KEY(key)) continue
    const value = target.getItem(key)
    if (value !== null) out[key] = value
  }
  return out
}

/**
 * Storage 전체 교체 — non-internal 통째 제거 후 payload 적용 (의사코드 11-2).
 * merge(setItem 만)면 stale 키가 남아 학생 A↔B 데이터 섞임 (06 ⑤). 명시적 replace.
 * internal 은 storage 자체 상태이므로 보존, payload 의 internal 키도 침투 차단.
 */
export const replaceStorage = (target: Storage, payload: Record<string, string>): void => {
  const keys: string[] = []
  for (let i = 0; i < target.length; i++) {
    const key = target.key(i)
    if (key !== null) keys.push(key)
  }
  keys.forEach((key) => {
    if (IS_INTERNAL_INTEGRATION_KEY(key)) return
    target.removeItem(key)
  })
  Object.entries(payload).forEach(([key, value]) => {
    if (IS_INTERNAL_INTEGRATION_KEY(key)) return
    target.setItem(key, value)
  })
}
